import styled from "styled-components";

const SearchBar = styled.input`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin-top: ${props => (props.map ? "0" : "40px")};
  position: relative;
  width: ${props => (props.map ? "calc(100% - 20px)" : "100%")};
  border-radius: 40px;
  height: 50px;
  border: none;
  background: ${props =>
    props.map ? "rgba(255, 255, 255, 0.8)" : "rgba(255, 255, 255, 0.1)"};
  border: 3px solid rgba(255, 255, 255, 0.6);
  outline: none;
  font-size: 18px;
  font-weight: 300;
  padding-left: 20px;
  box-shadow: 0px 4px 36px 0px rgba(50, 112, 250, 0);
  transition: all 0.2s ease-in;
  color: ${props => (props.map ? "rgba(50, 112, 250, 1)" : "white")};
  font-weight: 500;
  &::placeholder {
    color: ${props =>
      props.map ? "rgba(50, 112, 250, 1)" : "rgba(255, 255, 255, 0.8)"};
  }
  &:focus {
    box-shadow: 0px 4px 36px 0px rgba(50, 112, 250, 0.5);
    border-color: rgba(50, 112, 250, 1);
    background: ${props =>
      props.map ? "rgba(255, 255, 255, 1)" : "rgba(255, 255, 255, 0.3)"};
  }
`;

export default SearchBar;



// WEBPACK FOOTER //
// ./src/components/SearchBar.js